import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageHero from '@/components/PageHero';
import Section from '@/components/Section';
import FeatureCard from './components/FeatureCard';
import AbilityCard from './components/AbilityCard';
import ProductShowcase from './components/ProductShowcase';
import { HERO, FEATURES, ABILITIES } from './config';
import styles from './index.module.scss';

export default function Matrix() {
  return (
    <div className={styles.page}>
      <Header />
      <main>
        <PageHero image={HERO.image} innerClassName={styles.heroInner}>
          <h1>{HERO.title}</h1>
          <p>{HERO.subtitle}</p>
        </PageHero>

        <Section title={FEATURES.title} subTitle={FEATURES.subTitle}>
          <div className={styles.featureList}>
            {FEATURES.cards.map((item) => (
              <FeatureCard key={item.title} {...item} />
            ))}
          </div>
        </Section>

        <Section title={ABILITIES.title} subTitle={ABILITIES.subTitle}>
          <div className={styles.abilityGrid}>
            {ABILITIES.cards.map((item) => (
              <AbilityCard key={item.title} {...item} />
            ))}
          </div>
        </Section>

        <ProductShowcase />
      </main>
      <Footer />
    </div>
  );
}
